import { Admin, Resource, ListGuesser } from 'react-admin';
import instances from './instances';
import projects from './projects';
import schedules from './schedules';
import jobs from './jobs';
import azure_authentications from './azure_authentications';
import azure_storages from './azure_storages';
import database_items from './database_items';
import targets from './targets';
import resources from './resources';
import environments from './environments';
import { Layout } from './layout';
import { LoginPage } from './azlogin';

import authProvider from './authProvider';
import dataProvider from './dataProvider';

const { REACT_APP_BACKEND_URL } = process.env;

const App = () => (
    <Admin
        dataProvider={dataProvider(process.env.REACT_APP_BACKEND_URL)}
        authProvider={authProvider}
        loginPage={LoginPage}
        layout={Layout}
    >
        <Resource name="instances" {...instances} />
        <Resource name="projects" {...projects} />
        <Resource name="environments" {...environments} />
        <Resource name="schedules" {...schedules} />
        <Resource name="jobs" {...jobs} />

        <Resource name="azure_authentications" {...azure_authentications} />
        <Resource name="azure_storages" {...azure_storages} />
        <Resource name="database_items" {...database_items} />
        <Resource name="targets" {...targets} />
        <Resource name="users" list={ListGuesser} />
        <Resource name="resources" {...resources} />

    </Admin>
);

export default App;
